<div class="container-fluid psp-container">
    <div class="card mb-4">
        <div class="row align-items-center pt-3">
            <div class="col-lg-6 col-7">
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
                    <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li class="breadcrumb-item text-primary psp-breadcrumb">
                            <a class="text-primary" [routerLink]="'/psp-patients'"> PSP Patients </a>
                        </li>
                        <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
                            Patient Profile
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="border-bottom title d-flex p-3 justify-content-between align-items-center mt-2">
            <h2 class="m-0">PSP Patient's Profile</h2>
        </div>
        <div class="card-body">
            <div class="card-patient p-3">
                <div class="p-3 border-bottom" id="personal-details">
                    <h3>Personal Details</h3>
                    <div class="row justify-content-evenly">
                        <div class="col-md-3">
                            <h5>Full Name</h5>
                            <span id="fName">{{ patientInfo?.fullName || '--'}}</span>
                        </div>
                        <div class="col-md-3">
                            <h5>
                                {{
                                patientInfo?.nationalId && ! patientInfo?.passportId
                                ? 'National ID'
                                : ! patientInfo?.nationalId && patientInfo?.passportId
                                ? 'Passport ID'
                                : 'National ID / Passport ID'
                                }}
                                <button style="background: white; border: none; padding: 2; margin-left: 4px;"
                                    [disabled]="!finglodineSubscriptionData || !finglodineSubscriptionData?.nationalIdPaths"
                                    (click)="downloadNationalIdFile()">
                                    <span class="btn-inner--icon">
                                        <i class="fas fa-file-download fa-l"></i>
                                    </span>
                                </button>
                            </h5>
                            <span>
                                {{
                                patientInfo?.nationalId && ! patientInfo?.passportId
                                ? patientInfo?.nationalId
                                : ! patientInfo?.nationalId && patientInfo?.passportId
                                ? patientInfo?.passportId
                                : patientInfo?.nationalId && patientInfo?.passportId
                                ? patientInfo?.nationalId + ' / ' + patientInfo?.passportId
                                : '--'
                                }}
                            </span>
                        </div>

                        <div class="col-md-3">
                            <h5>Date of Birth</h5>
                            <span id="dob">{{ (patientInfo?.birthdate | date) || '--' }}</span>
                        </div>
                    </div>
                </div>
                <div class="p-3 border-bottom" id="phone-details">
                    <h3>Phone Details</h3>
                    <div class="row justify-content-evenly">
                        <div class="col-md-3">
                            <h5>Mobile Number</h5>
                            <span id="phone">{{ patientInfo?.phone || '--' }}</span>
                        </div>
                    </div>
                </div>
                <div class="p-3 border-bottom" id="location">
                    <h3>Location Details</h3>
                    <div class="row justify-content-evenly">
                        <div class="col-md-3">
                            <h5>Patient City</h5>
                            <span id="city">{{ patient?.personalInfo?.cityName || '--' }}</span>
                        </div>
                        <div class="col-md-3">
                            <h5>Patient Area</h5>
                            <span id="area">{{ patient?.personalInfo?.areaName || '--' }}</span>
                        </div>
                    </div>
                </div>
                <div class="p-3 border-bottom" id="location">
                    <h3>Physician's Details</h3>
                    <div class="row justify-content-evenly">
                        <div class="col-md-3">
                            <h5>Physician Name</h5>
                            <span id="name">{{ PSPpatientSubscription?.doctor?.name || '--' }}</span>
                        </div>
                        <div class="col-md-3">
                            <h5>Hospital / Clinic Name</h5>
                            <span id="hname">{{ PSPpatientSubscription?.hospital?.name || '--' }}</span>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-neutral"
                                [disabled]="!finglodineSubscriptionData || !this.finglodineSubscriptionData?.rxPath"
                                (click)="openAttachmentModal(this.finglodineSubscriptionData?.rxPath)">
                                <span class="btn-inner--icon">
                                    <i class="far fa-eye"></i>
                                </span>
                                <span class="btn-inner--text"> View Attachment </span>
                            </button>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-neutral"
                                [disabled]="!finglodineSubscriptionData || !finglodineSubscriptionData?.medicalReportPaths"
                                (click)="downloadMedicalReportsFiles()">
                                <span class="btn-inner--icon">
                                    <i class="fas fa-file-download"></i>
                                </span>
                                <span class="btn-inner--text"> Download Medical Reports
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-3" id="location">
                    <h3>Subscription Details</h3>
                    <div class="row justify-content-evenly">
                        <div class="col-md-3">
                            <h5>Program Name</h5>
                            <span id="city">{{ PSPpatientSubscription?.program?.name || '--' }}</span>
                        </div>
                        <div class="col-md-3">
                            <h5>Company Name</h5>
                            <span id="area">{{ PSPpatientSubscription?.program?.companyName || '--' }}</span>
                        </div>
                        <div class="col-md-3">
                            <h5>Activation Date</h5>
                            <span id="area">{{ (PSPpatientSubscription?.activationDate | date) || '--' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card mb-4">
        <div class="border-bottom title d-flex p-3 justify-content-between align-items-center mt-2">
            <h2 class="m-0">Uploading Tests Data</h2>
        </div>
        <div class="card-body border-bottom mb-3">
            <h3>Lab Tests</h3>
            <div class="row justify-content-evenly ">
                <div class="col-md-3">
                    <label class="form-control-label required" for="labs">
                        Labs
                    </label>
                    <select class="form-control" id="labsProviderTypeId" [(ngModel)]="labsProviderId">
                        <option [ngValue]="null" [disabled]="true">Select Lab</option>
                        <option *ngFor="let lab of labsProvidersList" [ngValue]="lab.id">
                            {{ lab.name }}
                        </option>
                    </select>
                    <small *ngIf="previousLabsUpload?.providerName">Previous value: {{ previousLabsUpload?.providerName
                        }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label" for="approvalRefLabs">
                        Approval Reference
                    </label>
                    <input [(ngModel)]="labsApprovalRefrence" type="text" id="approvalRefLabs"
                        class="input form-control" placeholder="Approval Reference" name="approvalRefLabs" />
                    <small
                        *ngIf="previousLabsUpload?.approvalReference && previousLabsUpload?.approvalReference !== 'null'">Previous
                        value: {{
                        previousLabsUpload?.approvalReference }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="labsRequestFiles">
                        Request Files
                    </label>
                    <input class="form-control" id="labsRequestFiles" type="file" name="labsRequestFiles" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onLabsFileSelected($event.target.files, 'request')" />
                    <small *ngIf="previousLabsUpload?.requestFilePaths.length > 0">{{ previousLabsUpload?.requestStatus
                        }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="labsResultsFiles">
                        Results Files
                    </label>
                    <input class="form-control" id="labsResultsFiles" type="file" name="labsResultsFiles" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onLabsFileSelected($event.target.files, 'result')" />
                    <small *ngIf="previousLabsUpload?.resultFilePaths.length > 0">{{ previousLabsUpload?.resultStatus
                        }}</small>
                </div>
            </div>
            <div class="form-actions d-flex justify-content-between">
                <div class="form-actions col-md-2">
                    <button class="btn next-btn" (click)="uploadLabsData()" [disabled]="isLabsFormNotValid()">
                        Upload Lab Tests
                    </button>
                </div>
                <div class="form-actions col-md-2">
                    <button class="btn next-btn" (click)="downloadLabsAttachements()" [disabled]="!previousLabsUpload">
                        Download Attachements
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body border-bottom mb-3">
            <h3>Radiologies</h3>
            <div class="row justify-content-evenly ">
                <div class="col-md-3">
                    <label class="form-control-label required" for="radios">
                        Radiology Providers
                    </label>
                    <select class="form-control" id="radiosProviderId" [(ngModel)]="radiosProviderId">
                        <option [ngValue]="null" [disabled]="true">Select Radiology Provider</option>
                        <option *ngFor="let radiosProvider of radiosProvidersList" [ngValue]="radiosProvider.id">
                            {{ radiosProvider.name }}
                        </option>
                    </select>
                    <small *ngIf="previousRadiosUpload?.providerName">Previous value: {{
                        previousRadiosUpload?.providerName }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label" for="approvalRefRadio">
                        Approval Reference
                    </label>
                    <input [(ngModel)]="radiosApprovalRefrence" type="text" id="approvalRefRadio"
                        class="input form-control" placeholder="Approval Reference" name="approvalRefRadio" />
                    <small
                        *ngIf="previousRadiosUpload?.approvalReference && previousRadiosUpload?.approvalReference !== 'null'">Previous
                        value: {{
                        previousRadiosUpload?.approvalReference }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="radioRequestFiles">
                        Request Files
                    </label>
                    <input class="form-control" id="radioRequestFiles" type="file" name="radioRequestFiles" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onRadiosFileSelected($event.target.files, 'request')" />
                    <small *ngIf="previousRadiosUpload?.requestFilePaths.length > 0">{{
                        previousRadiosUpload?.requestStatus }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="radioResultsFiles">
                        Results Files
                    </label>
                    <input class="form-control" id="radioResultsFiles" type="file" name="radioResultsFiles" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onRadiosFileSelected($event.target.files, 'result')" />
                    <small *ngIf="previousRadiosUpload?.resultFilePaths.length > 0">{{
                        previousRadiosUpload?.resultStatus }}</small>
                </div>
            </div>
            <div class="form-actions d-flex justify-content-between">
                <div class="form-actions col-md-2">
                    <button class="btn next-btn" (click)="uploadRadiosData()" [disabled]="isRadiosFormNotValid()">
                        Upload Radiologies
                    </button>
                </div>
                <div class="form-actions col-md-2">
                    <button class="btn next-btn" (click)="downloadRadiosAttachements()"
                        [disabled]="!previousRadiosUpload">
                        Download Attachements
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body mb-3">
            <h3>FDO</h3>
            <div class="row justify-content-evenly ">
                <div class="col-md-3">
                    <label class="form-control-label required" for="FDO">
                        FDO Providers
                    </label>
                    <select class="form-control" id="fdoProviderId" [(ngModel)]="fdoProviderId">
                        <option [ngValue]="null" [disabled]="true">Select FDO Provider</option>
                        <option *ngFor="let fdoProvider of fdoProvidersList" [ngValue]="fdoProvider.id">
                            {{ fdoProvider.name }}
                        </option>
                    </select>
                    <small *ngIf="previousFDOUpload?.providerName">Previous value: {{ previousFDOUpload?.providerName
                        }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label" for="approvalRefFDO">
                        Approval Reference
                    </label>
                    <input [(ngModel)]="fdoApprovalRefrence" type="text" id="approvalRefFDO" class="input form-control"
                        placeholder="Approval Reference" nameame="approvalRefFDO" />
                    <small
                        *ngIf="previousFDOUpload?.approvalReference && previousFDOUpload?.approvalReference !== 'null'">Previous
                        value: {{
                        previousFDOUpload?.approvalReference }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="FDORequestsFiles">
                        Request Files
                    </label>
                    <input class="form-control" id="FDORequestFiles" type="file" name="FDORequestFiles" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onFDOFileSelected($event.target.files, 'request')" />
                    <small *ngIf="previousFDOUpload?.requestFilePaths.length > 0">{{ previousFDOUpload?.requestStatus
                        }}</small>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label required" for="FDOResultsFile">
                        Results Files
                    </label>
                    <input class="form-control" id="FDOResultsFile" type="file" name="FDOResultsFile" lang="en"
                        accept=".doc,.docx,.pdf,image/*" multiple
                        (change)="onFDOFileSelected($event.target.files, 'result')" />
                    <small *ngIf="previousFDOUpload?.resultFilePaths.length > 0">{{ previousFDOUpload?.resultStatus
                        }}</small>
                </div>
            </div>
            <div class="form-actions d-flex justify-content-between">
                <div class="col-md-2">
                    <button class="btn next-btn" (click)="uploadFdoData()" [disabled]="isFDOFormNotValid()">
                        Upload FDO
                    </button>
                </div>
                <div class="col-md-2">
                    <button class="btn next-btn" (click)="downloadFDOAttachements()" [disabled]="!previousFDOUpload">
                        Download Attachments
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>